import axios from "axios";

export var main = axios.create();

// This instance is used so we don't touch the main instance
// We replace the auth token here with either a specific Auth0 token or a Whistle custom JWT
export var noAuth = axios.create();

// Whistle OAuth axios
export var oauth = axios.create({
  headers: { "x-whistle-oauth": 1 },
});

export default main;
